// extracted by mini-css-extract-plugin
export default {"addSupplierSidebarWrapper":"sidebar_addSupplierSidebarWrapper__QgNF5","sidebarItem":"sidebar_sidebarItem__sD9zb","sidebarActiveItem":"sidebar_sidebarActiveItem__eYrBK"};